import { useState, useMemo } from 'react';
import type { DragAndDropType, DragAndDropContextProviderProps } from '@app/services/aiFlow.types';
import { DragAndDropContext } from './useDragAndDrop';

const DragAndDropProvider = ({ children }: DragAndDropContextProviderProps) => {
    const [dragItemType, setDragItemType] = useState<DragAndDropType | null>(null);

    const value = useMemo(
        () => ({ dragItemType, setDragItemType }),
        [dragItemType, setDragItemType]
    );

    return <DragAndDropContext.Provider value={value}>{children}</DragAndDropContext.Provider>;
};

export default DragAndDropProvider;
